import React from "react";

const About = () => {
  return (
    <div>
      <h2>
        Formerly - Apple Computer Company (1976–1977) Apple Computer, Inc.
        (1977–2007) 
        <br />
        Type-Public 
        <br />
        Traded as - Nasdaq: AAPL Nasdaq-100 component DJIA
        component S&P 100 component S&P 500 component 
        <br />
        ISIN - US0378331005 
        <br />
        Industry - Consumer electronics, software and online services 
        <br />
        Founded - April 1,
        1976; 46 years ago in Los Altos, California, U.S. 
        <br />
        Founders - Steve Jobs
        Steve Wozniak Ronald Wayne 
        <br />
        Headquarters - 1 Apple Park Way, Cupertino,
        California, U.S. 
        <br />
        Number of locations - 517 retail stores (2021) Area
        served Worldwide
      </h2>
    </div>
  );
};

export default About;
